import { render } from "./Areas.vue?vue&type=template&id=b52b25ce&scoped=true"
import script from "./Areas.vue?vue&type=script&scoped=true&lang=js"
export * from "./Areas.vue?vue&type=script&scoped=true&lang=js"

import "./Areas.vue?vue&type=style&index=0&id=b52b25ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52b25ce"]])

export default __exports__